import { BrandMark } from "@/components/Brand";

export default function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="relative grain hidden lg:flex flex-col justify-between bg-[#19082B] p-14 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1699621106755-4fe40ce95d64?crop=entropy&cs=srgb&fm=jpg&q=70&w=1400"
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-20"
        />
        <div className="relative z-10"><BrandMark light /></div>
        <div className="relative z-10 space-y-6 max-w-md">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] font-semibold">Client Relationship Workspace</p>
          <h2 className="text-4xl xl:text-5xl font-extrabold text-white leading-[1.05]">VA BRAND BUILDER</h2>
          <p className="text-lg text-[#D4AF37] font-semibold tracking-wide">Powered by AVY</p>
        </div>
        <p className="relative z-10 text-xs text-white/50">© {new Date().getFullYear()} AVY · VA Brand Builder</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12 bg-white">
        <div className="w-full max-w-sm space-y-8 fade-up">
          <div className="lg:hidden"><BrandMark /></div>
          <div className="space-y-2">
            <h1 className="text-3xl font-extrabold tracking-tight text-[#19082B]">{title}</h1>
            {subtitle && <p className="text-sm text-stone-600">{subtitle}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
